



























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { apiStaffAllList, apiWorkerTypeList } from '@/api/work_order'

@Component
export default class StaffSelector extends Vue {
    @Prop({ type: Boolean, default: false }) visible!: boolean

    dialogVisible = false
    loading = false
    staffList: any[] = []
    workerTypeList: any[] = []
    selectedStaff: any[] = []
    selectedStaffIds: any[] = []

    // 分页参数
    currentPage = 1
    pageSize = 5
    total = 0

    // 搜索表单
    searchForm = {
      keyword: '',
      worker_type_id: ''
    }

    @Watch('visible')
    onVisibleChange (val: boolean) {
      this.dialogVisible = val
      if (val) {
        this.getStaffList()
        this.getWorkerTypeList()
      }
    }

    // 获取员工列表
    async getStaffList () {
      this.loading = true
      try {
        const params: any = {
          page: this.currentPage,
          limit: this.pageSize,
          ...this.searchForm
        }

        // 如果有搜索条件，使用分页接口；否则使用全量接口
        const res = await apiStaffAllList(params)
        this.staffList = res.lists || []
        this.total = res.total || 0
      } catch (error) {
        this.$message.error('获取员工列表失败')
      } finally {
        this.loading = false
      }
    }

    // 获取工种列表
    async getWorkerTypeList () {
      try {
        const res = await apiWorkerTypeList()
        this.workerTypeList = res.lists || []
      } catch (error) {
        console.error('获取工种列表失败:', error)
      }
    }

    // 搜索
    handleSearch () {
      this.currentPage = 1
      this.getStaffList()
    }

    // 重置
    handleReset () {
      this.searchForm = {
        keyword: '',
        worker_type_id: ''
      }
      this.currentPage = 1
      this.getStaffList()
    }

    // 分页变化
    handlePageChange (page: number) {
      this.currentPage = page
      this.getStaffList()
    }

    // 行点击事件
    handleRowClick (row: any) {
      // 切换行选择状态
      this.$nextTick(() => {
        const tableRef = this.$refs.staffTable as any
        if (tableRef && tableRef.toggleRowSelection) {
          const isSelected = this.selectedStaffIds.includes(row.id)
          tableRef.toggleRowSelection(row, !isSelected)
        }
      })
    }

    // 复选框选择事件
    handleSelectionChange (selection: any[]) {
      this.selectedStaff = selection
      this.selectedStaffIds = selection.map(item => item.id)
    }

    // 确认选择
    handleConfirm () {
      if (this.selectedStaff.length === 0) {
        this.$message.warning('请选择员工')
        return
      }

      this.$emit('confirm', this.selectedStaff)
      this.handleClose()
    }

    // 关闭对话框
    handleClose () {
      // 清除表格选择
      if (this.$refs.staffTable) {
        const tableRef = this.$refs.staffTable as any
        if (tableRef && tableRef.clearSelection) {
          tableRef.clearSelection()
        }
      }

      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.selectedStaff = []
      this.selectedStaffIds = []
    }

    // 获取薪酬单位
    getSalaryUnit (type: number): string {
      const unitMap: any = {
        1: '元/月',
        2: '元/小时',
        3: '元/天',
        4: '元/件'
      }
      return unitMap[type] || '元'
    }

    // 获取雇佣类型文本
    getEmploymentTypeText (type: number): string {
      const typeMap = ['', '全职直聘', '兼职', '临时工', '外包', '实习生']
      return typeMap[type] || '未知'
    }

    // 获取员工状态文本
    getStaffStatusText (status: number): string {
      const statusMap = ['', '在职', '离职', '停职']
      return statusMap[status] || '未知'
    }

    // 获取员工状态标签类型
    getStaffStatusTagType (status: number): string {
      const typeMap = ['', 'success', 'info', 'warning']
      return typeMap[status] || ''
    }

    // 获取当前状态文本
    getCurrentStatusText (status: number): string {
      const statusMap = ['', '空闲', '工作中', '休假', '请假']
      return statusMap[status] || '未知'
    }

    // 获取当前状态标签类型
    getCurrentStatusTagType (status: number): string {
      const typeMap = ['', 'info', 'primary', 'success', 'warning']
      return typeMap[status] || ''
    }
}
